import { render, staticRenderFns } from "./PatientsDataTable.vue?vue&type=template&id=16e99924"
import script from "./PatientsDataTable.vue?vue&type=script&lang=js"
export * from "./PatientsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports